import React from 'react';
import CategoryCardMobile from '../../components/category-card-mobile';

const SubcategoryListItemMobile = (props) => <CategoryCardMobile {...props} isSubcategory />;

export default SubcategoryListItemMobile;
